<div class="container">
  <div class="header-row phi-flex-center phi-justify-content-between phi-gap-12 w-100">
    <h6 class="pl-5">Create Video</h6>
    <!-- Close Button -->
    <!-- <div class="popup-close"> -->
      <span [mat-dialog-close] class="fs-24 material-icons popup-close-icon">close</span>
    <!-- </div> -->
  </div>
  
  <form [formGroup]="videoForm" (ngSubmit)="onSubmit()">
    <ion-row>
      
      <!-- Title -->
      <ion-col size="12" class="mt-10">
        <label>Title<span class="red-cl required">*</span></label>
        <textarea class="edittextarea w-100 mat-height40 mat-input-style mt-5 " formControlName="title"
        maxlength="255" rows="2"></textarea>
        <mat-error *ngIf="videoForm.get('title')?.hasError('required') && (videoForm.get('title')?.touched || submitted)">Title is required</mat-error>
      </ion-col>
      
      <!-- Description -->
      <ion-col size="12" class="mt-10">
        <label>Description</label>
        <textarea class="edittextarea w-100 mat-height40 mat-input-style mt-5" formControlName="description" maxlength="255" rows="2"></textarea>      
      </ion-col>
      
      <!-- URL -->
      <ion-col size="12" class="mt-10">
        <label>URL<span class="red-cl required">*</span></label>
        <mat-form-field class="w-100 mat-height40 mat-input-style mt-5">
          <input matInput formControlName="url" style="color:black" maxlength="255" />
        </mat-form-field>
        <mat-error *ngIf="videoForm.get('url')?.hasError('required') && (videoForm.get('url')?.touched || submitted)">Title is required</mat-error>    
      </ion-col>
      
    </ion-row>
    
    <!-- Buttons -->
    <div class="mt-10" class="button-actions">
      <!-- <ion-col size="12" class="button-actions"> -->
        <button type="button" class="add_btn fs-14" [style.background-color]="buttonColorName" (click)="onSubmit()">
          {{ getPatchData ? 'Update' : 'Save' }}
        </button>
        <button type="button" class="back_btn fs-14" (click)="onCancel()">
          Cancel
        </button>        
      <!-- </ion-col> -->
    </div>
  </form>
  
</div>